<!---
  <nz-form-item style="width: 100%;">
    <nz-form-label [nzOffset]="2" [nzSm]="6" [nzXs]="24" nzRequired nzFor="name">{{ model.Propertys.NAME.title}}</nz-form-label>
    <nz-form-control [nzSm]="12" [nzXs]="24" [nzErrorTip]="NameErrorTip">
      <ng-template #NameErrorTip let-control>
        <ng-container *ngIf="control.hasError('required')">{{ model.Propertys.NAME.hint }}</ng-container>
        <ng-container *ngIf="control.hasError('unique')">{{ control?.getError('unique') }}</ng-container>
        <ng-container *ngIf="control.hasError('server')">{{ control?.getError('server') }}</ng-container>
      </ng-template>
      <input nz-input formControlName="name" id="name" [placeholder]="model.Propertys.NAME.placeholder" cdkFocusInitial/>
    </nz-form-control>
  </nz-form-item>
  <nz-form-item style="width: 100%;">
    <nz-form-label [nzOffset]="2" [nzSm]="6" [nzXs]="24" nzFor="beschreibung">{{ model.Propertys.BESCHREIBUNG.title}}</nz-form-label>
    <nz-form-control [nzSm]="12" [nzXs]="24" [nzErrorTip]="BeschreibungErrorTip">
      <ng-template #BeschreibungErrorTip let-control>
        <ng-container *ngIf="control.hasError('required')">{{ model.Propertys.BESCHREIBUNG.hint }}</ng-container>
        <ng-container *ngIf="control.hasError('unique')">{{ control?.getError('unique') }}</ng-container>
        <ng-container *ngIf="control.hasError('server')">{{ control?.getError('server') }}</ng-container>
      </ng-template>
      <textarea nz-input formControlName="beschreibung" id="beschreibung" [placeholder]="model.Propertys.BESCHREIBUNG.placeholder"></textarea>
    </nz-form-control>
  </nz-form-item>
  <nz-form-item style="width: 100%;">
    <nz-form-label [nzOffset]="2" [nzSm]="6" [nzXs]="24" nzFor="finanzen">{{ model.Propertys.FINANZEN.title}}</nz-form-label>
    <nz-form-control [nzSm]="12" [nzXs]="24" [nzErrorTip]="FinanzenErrorTip">
      <ng-template #FinanzenErrorTip let-control>
        <ng-container *ngIf="control.hasError('required')">{{ model.Propertys.FINANZEN.hint }}</ng-container>
        <ng-container *ngIf="control.hasError('unique')">{{ control?.getError('unique') }}</ng-container>
        <ng-container *ngIf="control.hasError('server')">{{ control?.getError('server') }}</ng-container>
      </ng-template>
      <label nz-checkbox formControlName="finanzen" id="finanzen"></label>
    </nz-form-control>
  </nz-form-item>
  <nz-form-item style="width: 100%;">
    <nz-form-label [nzOffset]="2" [nzSm]="6" [nzXs]="24" nzFor="authorizedRoutes">Authorisierungen</nz-form-label>
    <nz-form-control [nzSm]="12" [nzXs]="24" >
      <pbc-page-authenticator formControlName="authorizedRoutes" id="authorizedRoutes"></pbc-page-authenticator>
    </nz-form-control>
  </nz-form-item>
  <nz-form-item style="width: 100%;">
    <nz-form-label [nzOffset]="2" [nzSm]="6" [nzXs]="24" nzFor="isAdmin">Administrator</nz-form-label>
    <nz-form-control [nzSm]="12" [nzXs]="24" >
      <label nz-checkbox formControlName="isAdmin" id="isAdmin"></label>
    </nz-form-control>
  </nz-form-item>
 -->
<nz-spin [nzSpinning]="$loading | async">
  <form nz-form [formGroup]="form" (ngSubmit)="submit()">
    <div formGroupName="rolle">
      <input class="cdk-visually-hidden" formControlName="id" id="id"/>
<!--- << content    -->
      <nz-form-item style="width: 100%;">
        <nz-form-label [nzOffset]="2" [nzSm]="6" [nzXs]="24" nzRequired nzFor="name">{{ model.Propertys.NAME.title}}</nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="24" [nzErrorTip]="model.Propertys.NAME.hint">
          <input nz-input formControlName="name" id="name" [placeholder]="model.Propertys.NAME.placeholder" cdkFocusInitial/>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item style="width: 100%;">
        <nz-form-label [nzOffset]="2" [nzSm]="6" [nzXs]="24" nzFor="finanzen">
          {{ model.Propertys.FINANZEN.title}}
          <i nz-icon nzType="euro" nzTheme="outline"></i>
        </nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="24" [nzErrorTip]="FinanzenErrorTip">
          <ng-template #FinanzenErrorTip let-control>
            <ng-container *ngIf="control.hasError('required')">{{ model.Propertys.FINANZEN.hint }}</ng-container>
            <ng-container *ngIf="control.hasError('unique')">{{ control?.getError('unique') }}</ng-container>
            <ng-container *ngIf="control.hasError('server')">{{ control?.getError('server') }}</ng-container>
          </ng-template>
          <label nz-checkbox formControlName="finanzen" id="finanzen"></label>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item style="width: 100%;">
        <nz-form-label [nzOffset]="2" [nzSm]="6" [nzXs]="24" nzFor="isAdmin">
          Administrator
          <i nz-icon nzType="unlock" nzTheme="outline"></i>
        </nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="24" >
          <label nz-checkbox formControlName="isAdmin" id="isAdmin"></label>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item style="width: 100%;">
        <nz-form-label [nzOffset]="2" [nzSm]="6" [nzXs]="24" nzFor="authorizedRoutes">Authorisierungen</nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="24" >
          <pbc-page-authenticator formControlName="authorizedRoutes" id="authorizedRoutes"></pbc-page-authenticator>
        </nz-form-control>
      </nz-form-item>
      <nz-form-item style="width: 100%;">
        <nz-form-label [nzOffset]="2" [nzSm]="6" [nzXs]="24" nzFor="beschreibung">{{ model.Propertys.BESCHREIBUNG.title}}</nz-form-label>
        <nz-form-control [nzSm]="12" [nzXs]="24" >
          <textarea nz-input formControlName="beschreibung" id="beschreibung" [placeholder]="model.Propertys.BESCHREIBUNG.placeholder"></textarea>
        </nz-form-control>
      </nz-form-item>
<!---    content >> -->
      <nz-form-item>
        <nz-form-control [nzOffset]="16">
          <button nz-button nzType="primary" type="submit" [nzLoading]="$loading | async" [disabled]="!form.valid || ($loading | async)">
            <i nz-icon nzType="check-circle" nzTheme="outline"></i>
            Speichern
          </button>
        </nz-form-control>
      </nz-form-item>
    </div>
  </form>
<!--- << extra    -->
  <ng-container *ngIf="canUpdateMembers">
    <nz-divider></nz-divider>
    <nz-form-item style="width: 100%;">
      <nz-form-label [nzOffset]="2" [nzSm]="6" [nzXs]="24" nzFor="name">Mitgliedschaften</nz-form-label>
      <nz-form-control [nzSm]="12" [nzXs]="24">
        <nz-row>
          <nz-col nzFlex>
            <pbc-select-value width="264px" [value]="$members | async" (valueChange)="$members.next($event)" [shapes]="$mitarbeiter | async" mode="multiple" ></pbc-select-value>
          </nz-col>
          <nz-col nzFlex>
            <button nz-button nzType="primary" (click)="updateMembers()" [nzLoading]="$membering | async" [disabled]="!($membersChanged | async)">
              <i nz-icon nzType="usergroup-add" nzTheme="outline"></i>
              Speichern
            </button>
          </nz-col>
        </nz-row>
      </nz-form-control>
    </nz-form-item>
  </ng-container>
<!---    extra >> -->
</nz-spin>
